<div class="pt-2 pb-3">
  <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
    <form [formGroup]="billboardImgEditForm">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.name' | translate}}</mat-label>
        <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}" data-nar="billboardimage-widget-name">
      </mat-form-field>

      <div class="d-flex flex-row">
        <mat-form-field appearance="outline" class="w-100 mb-2 link-field">
          <mat-label>{{ 'pass.link-URL' | translate }}</mat-label>

          @if (linkChip; as chip) {
            <mat-chip-set matPrefix class="link-chip-prefix">
              <mat-chip-row (removed)="clearLinkChip()">
                <div class="d-flex align-items-center">
                  <mat-icon class="material-symbols-outlined chip-icon">
                    {{ chip.kind === 'child' ? 'link' : 'anchor' }}
                  </mat-icon>
                  <span class="chip-text">{{ chip.label }}</span>
                  <button matChipRemove type="button" aria-label="Remove" [disabled]="translationModeOriginal">
                    <mat-icon class="material-symbols-outlined">close</mat-icon>
                  </button>
                </div>
              </mat-chip-row>
            </mat-chip-set>
          }

          <input
            matInput
            formControlName="linkURL"
            type="url"
            placeholder="https://..."
            [readonly]="!!linkChip"
            [class.input-hidden]="!!linkChip"
            />

          <button
            mat-icon-button
            matSuffix
            [matMenuTriggerFor]="linkMenu"
            matTooltip="{{ 'pick_link_target' | translate }}"
            [disabled]="translationModeOriginal"
            type="button"
            >
            <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
          </button>

          @if (billboardImgEditForm.controls['linkURL']?.hasError('invalidCharacters')) {
            <mat-error>
              {{ 'invalid_characters' | translate }}
            </mat-error>
          }
          @if (billboardImgEditForm.controls['linkURL']?.hasError('pattern')
            && !billboardImgEditForm.controls['linkURL']?.hasError('invalidCharacters')) {
            <mat-error>
              {{ 'url_pattern_invalid' | translate }}
            </mat-error>
          }
          <mat-hint>{{ 'url_pattern_detailed' | translate }}</mat-hint>
        </mat-form-field>

        <input type="file" id="documentFile" name="documentFile" style="display: none;" accept=".pdf, .jpg, .png, .jpeg, .doc, .docx, .xls, .xlsx, .txt, .csv, .vcf, .rtf, .webp" (change)="readDocument($event)" #documentFileInput>

        <!-- Main menu -->
        <mat-menu #linkMenu="matMenu">
          <ng-template matMenuContent let-button="button">
            @if (anchorOptions?.length) {
              <button
                mat-menu-item
                [matMenuTriggerFor]="anchorMenu"
                >
                <mat-icon class="material-symbols-outlined">anchor</mat-icon>
                <span>{{ 'pass.linkWidgetUrl' | translate }}</span>
              </button>
            }
            @if (childPages?.length) {
              <button
                mat-menu-item
                [matMenuTriggerFor]="childMenu"
                >
                <mat-icon class="material-symbols-outlined">link</mat-icon>
                <span>{{ 'pass.linkChildPage' | translate }}</span>
              </button>
            }
            <button
              mat-menu-item
              (click)="documentFileInput.click()"
              matTooltip="{{'pick' | translate}}"
              [disabled]="translationModeOriginal"
              >
              <mat-icon class="material-symbols-outlined">folder_open</mat-icon>
              <span>{{'pass.browse' | translate}}</span>
            </button>
          </ng-template>
        </mat-menu>
        <!-- Anchors submenu -->
        <mat-menu #anchorMenu="matMenu">
          <ng-template matMenuContent let-button="button">
            <button mat-menu-item disabled>
              {{ 'widgets' | translate }}
            </button>
            @for (a of anchorOptions; track a) {
              <button
                mat-menu-item
                (click)="setLinkUrl(buildAnchorUrl(a))"
                >
                <span>{{ a.label || a.name || a.id }}</span>
              </button>
            }
          </ng-template>
        </mat-menu>
        <!-- Child pages submenu -->
        <mat-menu #childMenu="matMenu">
          <ng-template matMenuContent let-button="button">
            <button mat-menu-item disabled>
              {{ 'pass.pageTabLabels' | translate }}
            </button>
            @for (c of childPages; track c) {
              <button
                mat-menu-item
                (click)="setLinkUrl(buildChildPageUrl(c))"
                >
                <span>{{ c.name || c.id }}</span>
              </button>
            }
          </ng-template>
        </mat-menu>
      </div>

      <mat-card class="mb-4">
        <mat-card-content>
          <div class="p-2">
            @if (urlData || dynamicUrl) {
              <div >
                <div class="d-flex align-items-center mb-3">
                  <mat-icon class="material-symbols-outlined" >image</mat-icon>
                  <span class="px-2">{{'pass.widgets.img' | translate}}</span>
                </div>
                <div class="d-flex justify-content-stretch flex-column">
                  <div class="custom-form-field" >
                    <img [src]="urlData" style="width:100%; border-radius:5px;" onerror="this.src='./../../assets/img/default.jpg'" >
                  </div>
                  @if (!urlData) {
                    <div class="custom-form-field" [ngStyle]="{'background-image': 'url( ./../../assets/img/default.jpg)'}"></div>
                  }
                  <div class="form-fields mt-3">
                    <div class="d-flex align-items-center">
                      <mat-form-field appearance="outline" class="flex-grow-1">
                        <mat-icon matIconPrefix class="material-symbols-outlined">link</mat-icon>
                        <mat-label>{{ 'pass.url' | translate }}</mat-label>
                        <input type="text" formControlName="url" matInput (change)="checkNewUrl()" data-nar="billboardimage-widget-image-source">
                        <button mat-icon-button matSuffix (click)="deleteImg(url)"
                          class="delete-button" matTooltip="{{ 'pass.deleteIMG' | translate }}" [disabled]="translationModeOriginal">
                          <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                        @if (billboardImgEditForm.controls['url']?.hasError('invalidCharacters')) {
                          <mat-error>
                            {{ 'invalid_characters' | translate }}
                          </mat-error>
                        }
                        @if (billboardImgEditForm.controls['url']?.hasError('pattern') && !billboardImgEditForm.controls['url']?.hasError('invalidCharacters')) {
                          <mat-error>
                            {{ 'url_pattern_invalid' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </div>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'pass.altTitle' | translate}}</mat-label>
                    <input formControlName="altTitle" type="text" matInput placeholder="{{'pass.altTitle' | translate}}" data-nar="billboardimage-widget-alt">
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'pass.fallbackUrl' | translate}}</mat-label>
                    <input formControlName="fallbackUrl" type="text" matInput placeholder="{{'pass.fallbackUrl' | translate}}">
                    @if (billboardImgEditForm.controls['fallbackUrl']?.hasError('invalidCharacters')) {
                      <mat-error>
                        {{ 'invalid_characters' | translate }}
                      </mat-error>
                    }
                    @if (billboardImgEditForm.controls['fallbackUrl']?.hasError('pattern') && !billboardImgEditForm.controls['fallbackUrl']?.hasError('invalidCharacters')) {
                      <mat-error>
                        {{ 'url_pattern_invalid' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            }

            @if (!urlData && !dynamicUrl) {
              <div>
                <div class="d-flex align-items-center mb-3">
                  <mat-icon class="material-symbols-outlined">image</mat-icon>
                  <span class="px-2">{{'pass.widgets.img' | translate}}</span>
                </div>
                <div [app-drag-file-browse-ui]="dragFileData" (returnChanges)="returnChangesDragFileBrowseUI($event)"></div>
              </div>
            }
          </div>
        </mat-card-content>
      </mat-card>
    </form>
  </section>
  <div [app-widget-edit-filters] = "{'form': billboardImgEditForm.value, 'widgetData': data}"  (returnChanges)="returnChangesFilters($event)"></div>
</div>